import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-asterisk",
  "use": "svg-icon-asterisk-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 14\" id=\"svg-icon-asterisk\"><path d=\"M12.371 10.394a1.116 1.116 0 01-1.53.41L7.491 8.87v3.87a1.12 1.12 0 01-2.24 0v-3.87L1.9 10.804a1.117 1.117 0 01-1.53-.41 1.118 1.118 0 01.41-1.529L4.13 6.93.778 4.995a1.12 1.12 0 111.12-1.94L5.25 4.99V1.12a1.12 1.12 0 012.24 0v3.87l3.35-1.935a1.12 1.12 0 111.12 1.94L8.61 6.928l3.35 1.935c.536.31.72.994.411 1.53z\" fill=\"#717B7F\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol